import { Component, OnInit } from '@angular/core';
import { InfoService } from 'src/app/service/info.service';
import { LoginService } from 'src/app/service/login.service';
import { ParametrosService } from 'src/app/service/parametros.service';

@Component({
  selector: 'app-puntos-venta',
  templateUrl: './puntos-venta.component.html',
  styleUrls: ['./puntos-venta.component.scss']
})
export class PuntosVentaComponent implements OnInit {
  msjError: any;
  session: any;
  lista: any[] = [];

  constructor(private parametrosService: ParametrosService, private login: LoginService) {
    this.session = JSON.parse(localStorage.getItem('sesionPocae'))
  }

  filter = '';
  pVenta: any[];
  numParametro: number;
  error: boolean;
  loading: boolean;
  noResults: boolean;

  async ngOnInit() {
    this.numParametro = 26004;
    this.error = false;
    this.msjError = '';
    this.loading = false;

    await this.getPuntosVenta();
  }

  async getPuntosVenta() {
    this.loading = true;
    try {
      const res = await this.parametrosService.fetchParametros(this.numParametro);

      if (!res || !res.ok) {
        this.error = true;
        this.msjError = res?.message || 'Error al obtener datos';
        this.pVenta = [];
      } else {
        const data = (res as any).data || {};

        if (Array.isArray(data.parametros) && data.parametros.length) {
            this.pVenta = data.parametros.filter(
            (p: any) => p.sIndicador02 === 'S' && p.sIndicador03 === 'S'
          );
          this.noResults = this.pVenta.length === 0;
        } else {
          // this.pVenta = data || [];
          this.pVenta = data || [];
          this.noResults = true;
        }

      this.error = false;
      }
    } catch (err) {
      this.error = true;
      this.msjError = 'Error inesperado';
      this.pVenta = [];
    } finally {
      this.loading = false;
    }
  }
}
